import React, { useState } from 'react';

const LandingPageModule = ({
    enableAgeGate = true,
    ageGateStorageKey = 'tako8_age_verified',
    onJoinMember,
    onViewProducts,
    logoSrc = process.env.PUBLIC_URL + '/images/TAKO-LOGO.png',
    backgroundTentaclePngSrc = process.env.PUBLIC_URL + '/images/2258.png',
    brandTentacleSvgSrc = process.env.PUBLIC_URL + '/images/octo-tentacle.svg',
    videoSrcA = process.env.PUBLIC_URL + '/images/Keevx_image_to_video_2026-01-04 18_05_52.mp4',
    videoSrcB = process.env.PUBLIC_URL + '/images/i2v-196f7c97bf114f2dbfb4b547abdfe508.mp4',
    nav = {
        brandStoryLabel: '品牌故事',
        productsLabel: '商品預覽',
        howItWorksLabel: '如何使用'
    },
    hero = {
        brandNameLeft: 'TAKO',
        brandNameRight: '8',
        headline: '同樣的價格，讓你的酒更好喝',
        headlineEmphasis: '更好喝',
        subHeadline: '買酒找TAKO8（章魚發）就對了',
        description: '每一分節省都直接回饋給您，還要想辦法讓酒更好喝。'
    },
    heroCard = {
        badge: '最在地的 O2O 酒類社群電商',
        titleA: '觸角',
        titleB: '急送',
        desc: '你要的酒就在巷口。線上預約、巷口取貨，前所未有的便利體驗。',
        buttonText: '即刻體驗 八爪章魚的觸角急送 ➔'
    },
    legal = {
        warningLeft: '禁止酒駕',
        warningRight: '未滿18歲禁止飲酒'
    }
}) => {
    const [ageVerified, setAgeVerified] = useState(() => {
        if (!enableAgeGate) return true;
        return localStorage.getItem(ageGateStorageKey) === 'true';
    });

    if (!ageVerified) {
        return (
            <div className="fixed inset-0 z-[9999] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
                <div className="bg-gray-900 border-2 border-[#d4af37] rounded-2xl p-8 md:p-12 max-w-md w-full shadow-2xl">
                    <div className="text-center mb-8">
                        <div className="text-6xl mb-4">🍷</div>
                        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">年齡確認</h2>
                        <p className="text-gray-300 text-lg">根據法規，本網站僅供 18 歲以上成人使用</p>
                    </div>

                    <div className="space-y-4">
                        <button
                            onClick={() => {
                                localStorage.setItem(ageGateStorageKey, 'true');
                                setAgeVerified(true);
                            }}
                            className="w-full bg-[#d4af37] text-gray-900 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-[#e5c158] transition-all duration-300"
                        >
                            我已滿 18 歲
                        </button>
                        <button
                            onClick={() => {
                                alert('很抱歉，您必須年滿 18 歲才能使用本服務。');
                                window.location.href = 'https://www.google.com';
                            }}
                            className="w-full bg-gray-700 text-gray-300 px-8 py-4 rounded-xl font-bold text-lg hover:bg-gray-600 transition-all duration-300"
                        >
                            我未滿 18 歲
                        </button>
                    </div>

                    <p className="text-xs text-gray-500 text-center mt-6">
                        本網站僅供產品資訊瀏覽，恕不提供線上交易。<br />
                        所有交付行為均由物流人員（或店取人員）核對身分證件後方可完成。
                    </p>
                </div>
            </div>
        );
    }

    const scrollToId = (id) => {
        const el = document.getElementById(id);
        if (!el) return;
        window.scrollTo({ top: el.offsetTop - 80, behavior: 'smooth' });
    };

    return (
        <div
            className="min-h-screen bg-gray-900 text-gray-100 font-sans selection:bg-[#d4af37] selection:text-gray-900"
            style={{ fontFamily: "'Inter', sans-serif" }}
        >
            <style>{`
                @keyframes octo-float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-20px); }
                }
                @keyframes shimmer {
                    0% { transform: translateX(-150%) skewX(-12deg); }
                    100% { transform: translateX(150%) skewX(-12deg); }
                }
                @keyframes tentacle-wave {
                    0%, 100% { transform: rotate(-5deg) translateY(0) scale(1); }
                    50% { transform: rotate(5deg) translateY(-20px) scale(1.1); }
                }
                @keyframes tentacle-breathe {
                    0%, 100% {
                        opacity: 0.15;
                        transform: scale(1);
                    }
                    50% {
                        opacity: 0.25;
                        transform: scale(1.03);
                    }
                }
                .animate-octo-float { animation: octo-float 6s ease-in-out infinite; }
                .animate-shimmer { animation: shimmer 3s infinite; }
                .animate-tentacle-wave { animation: tentacle-wave 12s ease-in-out infinite; }
                .animate-tentacle-breathe { animation: tentacle-breathe 4s ease-in-out infinite; }
            `}</style>

            <header className="fixed w-full top-0 z-50 bg-gray-950/80 backdrop-blur-sm shadow-lg border-b border-white/5">
                <nav className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
                    <div className="text-2xl font-extrabold flex items-center gap-3">
                        <img
                            src={logoSrc}
                            alt="Logo"
                            className="h-12 w-auto object-contain drop-shadow-[0_0_5px_rgba(212,175,55,0.5)] filter brightness-110 sepia-[.3] saturate-[1.5] hue-rotate-[-10deg]"
                        />
                        <div className="flex items-baseline">
                            <span className="text-white">{hero.brandNameLeft}</span>
                            <span className="text-yellow-400">{hero.brandNameRight}</span>
                        </div>
                    </div>

                    <div className="hidden md:flex space-x-8 text-sm items-center font-medium text-gray-300">
                        <button
                            onClick={() => scrollToId('brand-story')}
                            className="hover:text-[#d4af37] transition duration-200"
                        >
                            {nav.brandStoryLabel}
                        </button>
                        <button
                            onClick={() => scrollToId('products')}
                            className="hover:text-[#d4af37] transition duration-200"
                        >
                            {nav.productsLabel}
                        </button>
                        <button
                            onClick={() => scrollToId('how-it-works')}
                            className="hover:text-[#d4af37] transition duration-200"
                        >
                            {nav.howItWorksLabel}
                        </button>
                    </div>

                    <button
                        onClick={onJoinMember}
                        className="bg-[#d4af37] text-gray-900 px-5 py-2 rounded-full font-bold text-sm shadow-[0_0_15px_rgba(212,175,55,0.3)] hover:bg-[#e5c158] hover:shadow-[0_0_25px_rgba(212,175,55,0.5)] transition duration-300"
                    >
                        會員登入
                    </button>
                </nav>
            </header>

            <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-0">
                <div className="absolute inset-0 bg-gray-900">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#d4af37]/10 via-gray-900 to-gray-950"></div>
                    <div className="absolute -left-[20%] -top-[20%] w-[100%] h-[150%] pointer-events-none opacity-[0.07] mix-blend-screen z-0 overflow-visible">
                        <img
                            src={backgroundTentaclePngSrc}
                            alt="Background"
                            className="w-full h-full object-contain filter invert sepia saturate-[3] hue-rotate-[10deg] animate-octo-float"
                            style={{ transform: 'rotate(-45deg)' }}
                        />
                    </div>
                </div>

                <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-center gap-12 lg:gap-24">
                    <div className="w-full max-w-xl flex flex-col items-center md:items-start text-center md:text-left">
                        <div className="mb-6 relative group">
                            <div className="absolute -inset-10 bg-[#d4af37] rounded-full blur-[80px] opacity-20 group-hover:opacity-30 transition duration-1000"></div>
                            <img
                                src={logoSrc}
                                alt="Logo"
                                className="h-48 md:h-64 w-auto object-contain rounded-full drop-shadow-[0_0_30px_rgba(212,175,55,0.6)] mix-blend-screen filter brightness-110 contrast-125 sepia-[.5] hue-rotate-[5deg] saturate-[2]"
                            />
                        </div>

                        <h1 className="text-5xl md:text-7xl font-black text-white mb-2 tracking-tighter drop-shadow-2xl">
                            {hero.brandNameLeft}
                            <span className="text-[#d4af37]">{hero.brandNameRight}</span>
                        </h1>

                        <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4 leading-tight drop-shadow-md">
                            {hero.headline.split(hero.headlineEmphasis)[0]}
                            <span className="text-[#d4af37]">{hero.headlineEmphasis}</span>
                            {hero.headline.split(hero.headlineEmphasis)[1] || ''}
                        </h2>

                        <p className="text-[#d4af37] text-xl md:text-2xl font-bold mb-6 leading-relaxed">
                            {hero.subHeadline.replace('TAKO8', '')}
                            <span className="text-white">TAKO8</span>
                            {hero.subHeadline.includes('TAKO8') ? hero.subHeadline.split('TAKO8')[1] : ''}
                        </p>

                        <div className="text-gray-300 text-base max-w-md leading-relaxed mb-6">
                            <p className="text-lg leading-relaxed">
                                {hero.description.split('更好喝')[0]}
                                <span className="text-[#d4af37] font-bold">更好喝</span>
                                {hero.description.split('更好喝')[1] || ''}
                            </p>
                        </div>
                    </div>

                    <div className="w-full max-w-lg">
                        <div
                            className="relative group cursor-pointer transform hover:scale-[1.02] transition-all duration-300"
                            onClick={onJoinMember}
                        >
                            <div className="absolute -inset-1 bg-gradient-to-br from-blue-600 via-indigo-900 to-purple-900 rounded-2xl blur opacity-60 group-hover:opacity-90 transition duration-500 animate-pulse"></div>

                            <div className="relative bg-gray-900/95 backdrop-blur-xl border border-blue-500/50 rounded-2xl p-8 flex flex-col justify-between min-h-[320px] shadow-2xl overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full animate-shimmer z-0"></div>

                                <div className="absolute -right-16 -bottom-16 w-[130%] h-[130%] pointer-events-none z-0 animate-tentacle-wave opacity-20 mix-blend-screen">
                                    <img
                                        src={backgroundTentaclePngSrc}
                                        alt="Tentacle"
                                        className="w-full h-full object-contain filter invert contrast-150"
                                        style={{ transformOrigin: 'bottom right' }}
                                    />
                                </div>

                                <div className="relative z-10">
                                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 border border-blue-500/40 text-xs font-bold mb-4">
                                        <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse"></span>
                                        {heroCard.badge}
                                    </div>
                                    <h3 className="text-5xl font-black text-white mb-4 leading-[1.1] tracking-tight">
                                        {heroCard.titleA}
                                        <br />
                                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-300">
                                            {heroCard.titleB}
                                        </span>
                                    </h3>
                                    <p className="text-gray-300 text-base font-medium leading-relaxed border-l-4 border-blue-500 pl-4">
                                        {heroCard.desc}
                                    </p>
                                </div>

                                <div className="pt-6 mt-auto relative z-10">
                                    <button
                                        onClick={
                                            onViewProducts ||
                                            (() => scrollToId('products'))
                                        }
                                        className="w-full flex items-center justify-center gap-3 bg-blue-600 text-white px-6 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-blue-500 transition-all group-hover:translate-x-1"
                                    >
                                        {heroCard.buttonText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-24 bg-gray-900 relative overflow-hidden">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-gradient-to-br from-indigo-900/30 via-purple-900/30 to-[#d4af37]/20 rounded-2xl p-8 md:p-12 border border-indigo-500/30 relative overflow-hidden">
                        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-indigo-500/20 rounded-full blur-3xl"></div>
                        <div className="relative z-10">
                            <div className="text-center mb-8">
                                <span className="text-indigo-400 font-bold tracking-wider text-sm uppercase mb-2 block">"Ture Tin Effect"</span>
                                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                                    為了讓酒<span className="text-[#d4af37]">更好喝</span>，我們推出了<span className="text-[#d4af37]">神奇的八筒</span>
                                </h3>
                                <p className="text-lg text-gray-300 mb-6 max-w-3xl mx-auto leading-relaxed px-4">
                                    用純錫八筒的錫離子效應，幾分鐘內就可讓酒變得更順口好喝並加速釋放香氣。<br className="hidden md:block" />
                                    你可以叫它<span className="text-[#d4af37] font-bold">聽八筒（TIN 8 筒）</span>或直接叫它<span className="text-[#d4af37] font-bold">八筒</span>
                                </p>
                            </div>

                            <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8 max-w-3xl mx-auto">
                                <div
                                    className="relative group overflow-hidden rounded-xl bg-black/50 border border-gray-700/50 shadow-2xl"
                                    style={{ aspectRatio: '4/3' }}
                                >
                                    <div className="absolute inset-0 overflow-hidden">
                                        <video
                                            src={videoSrcA}
                                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-500"
                                            style={{
                                                objectPosition: 'center center',
                                                height: '110%',
                                                transform: 'translateY(-5%)'
                                            }}
                                            autoPlay
                                            loop
                                            muted
                                            playsInline
                                        />
                                    </div>
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end justify-center p-3 md:p-4 pointer-events-none">
                                        <p className="text-white font-bold text-sm md:text-lg">神奇的八筒</p>
                                    </div>
                                </div>
                                <div
                                    className="relative group overflow-hidden rounded-xl bg-black/50 border border-gray-700/50 shadow-2xl"
                                    style={{ aspectRatio: '4/3' }}
                                >
                                    <div className="absolute inset-0 overflow-hidden">
                                        <video
                                            src={videoSrcB}
                                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-500"
                                            style={{
                                                objectPosition: 'center center',
                                                height: '110%',
                                                transform: 'translateY(-5%)'
                                            }}
                                            autoPlay
                                            loop
                                            muted
                                            playsInline
                                        />
                                    </div>
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end justify-center p-3 md:p-4 pointer-events-none">
                                        <p className="text-white font-bold text-sm md:text-lg">神奇的八筒</p>
                                    </div>
                                </div>
                            </div>

                            <div className="max-w-3xl mx-auto space-y-6 text-gray-300 leading-relaxed">
                                <p className="text-lg text-center px-4 leading-relaxed">
                                    放入 TAKO8 「八筒」，啟動 <span className="text-[#d4af37] font-bold">「八筒效應」</span>。<br className="hidden md:block" />
                                    讓您的飲酒時刻變成一場讓風味「胡牌」的科學儀式。
                                </p>
                                <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700">
                                    <p className="text-2xl font-bold text-[#d4af37] mb-4 text-center">你的酒聽牌了？！</p>
                                    <p className="text-base text-gray-300 text-center leading-relaxed">
                                        你可以告訴朋友，他的酒聽牌了，來了八筒就更順口好喝，這叫<span className="text-[#d4af37] font-bold">聽八筒</span>。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="how-it-works" className="py-16 bg-gray-900 border-b border-white/5">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-12 flex items-center justify-center gap-3 flex-wrap">
                        <span>
                            <span className="text-[#d4af37] mr-2">ⓘ</span> 簡單三步驟，輕鬆品味
                        </span>
                    </h3>
                    <div className="grid md:grid-cols-3 gap-8 relative">
                        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-transparent via-[#d4af37]/30 to-transparent z-0"></div>

                        <div className="relative z-10 flex flex-col items-center group">
                            <div className="w-24 h-24 bg-gray-900 rounded-full border-2 border-[#d4af37] flex items-center justify-center text-4xl shadow-[0_0_20px_rgba(212,175,55,0.2)] mb-6 group-hover:scale-110 group-hover:bg-[#d4af37] group-hover:text-gray-900 transition-all duration-300">
                                📱
                            </div>
                            <h4 className="text-xl font-bold text-white mb-2">線上詢價</h4>
                            <p className="text-gray-400">保留庫存</p>
                        </div>

                        <div className="relative z-10 flex flex-col items-center group">
                            <div className="w-24 h-24 bg-gray-900 rounded-full border-2 border-[#d4af37] flex items-center justify-center text-4xl shadow-[0_0_20px_rgba(212,175,55,0.2)] mb-6 group-hover:scale-110 group-hover:bg-[#d4af37] group-hover:text-gray-900 transition-all duration-300">
                                📍
                            </div>
                            <h4 className="text-xl font-bold text-white mb-1">前往附近據點</h4>
                            <p className="text-gray-400 mb-2">出示取貨碼</p>
                            <div className="text-[#d4af37]/30 text-xs tracking-[0.2em] font-mono select-none">:::📍:::</div>
                        </div>

                        <div className="relative z-10 flex flex-col items-center group">
                            <div className="w-24 h-24 bg-gray-900 rounded-full border-2 border-[#d4af37] flex items-center justify-center text-4xl shadow-[0_0_20px_rgba(212,175,55,0.2)] mb-6 group-hover:scale-110 group-hover:bg-[#d4af37] group-hover:text-gray-900 transition-all duration-300">
                                💳
                            </div>
                            <h4 className="text-xl font-bold text-white mb-2">現場付款</h4>
                            <p className="text-gray-400">驗證取貨</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="products" className="py-20 bg-gray-950 relative border-t border-white/5">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-4xl md:text-5xl font-black text-white mb-4">精選酒款預覽</h2>
                    <p className="text-xl text-gray-400 mb-8">立即登入瀏覽完整商品目錄</p>
                    <button
                        onClick={onViewProducts || onJoinMember}
                        className="px-10 py-5 bg-[#d4af37] text-gray-900 rounded-full font-black text-lg shadow-xl hover:bg-[#e5c158] hover:scale-105 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] transition duration-300"
                    >
                        即刻體驗 →
                    </button>
                </div>
            </section>

            <section id="brand-story" className="py-24 bg-gray-900 relative overflow-hidden">
                <div className="absolute inset-0 z-0 overflow-hidden">
                    <div className="absolute inset-0 animate-tentacle-breathe">
                        <img
                            src={brandTentacleSvgSrc}
                            alt="Tentacle Background"
                            className="w-full h-full object-cover opacity-40"
                        />
                    </div>
                </div>

                <div className="relative z-10 px-4 sm:px-6 lg:px-8">
                    <div className="max-w-4xl mx-auto">
                        <div
                            className="bg-gray-900/80 backdrop-blur-lg rounded-2xl p-8 md:p-12 border border-blue-500/30 shadow-2xl relative overflow-hidden"
                            style={{
                                boxShadow:
                                    '0 0 40px rgba(59, 130, 246, 0.3), 0 0 80px rgba(59, 130, 246, 0.15), inset 0 0 40px rgba(59, 130, 246, 0.1)'
                            }}
                        >
                            <div className="absolute -inset-1 bg-gradient-to-r from-blue-500/20 via-cyan-500/20 to-blue-500/20 rounded-2xl blur-xl opacity-50 animate-pulse"></div>
                            <div className="relative z-10">
                                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center">為什麼是章魚？</h1>

                                <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed">
                                    <p>
                                        章魚屬於<span className="text-[#d4af37] font-bold">八腕目</span>，特徵是擁有<span className="text-[#d4af37] font-bold">八條腕足</span>
                                    </p>
                                    <p>
                                        而人不知道的是牠有<span className="text-[#d4af37] font-bold">3顆心臟9個腦</span>，<br />
                                        是超級有腦具備學習及創新能力的海洋動物。
                                    </p>
                                    <p className="pt-4 border-t border-white/10">
                                        而 TAKO8 是一個用心且創新的酒類電商平台，<br />
                                        我們的主旨是創造出<br />
                                        一個<span className="text-[#d4af37] font-bold">便宜好康又好喝又能便捷配送到各地</span>的驗酒體驗<br />
                                        所以我們用<span className="text-[#d4af37] font-bold">TAKO8（章魚發）</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="bg-gray-950 pt-12 pb-[12vh] text-center text-gray-500 text-sm border-t border-gray-900">
                <div className="max-w-4xl mx-auto px-4">
                    <p className="mb-4">&copy; 2025 TAKO8. All rights reserved.</p>
                    <div className="mt-6 pt-6 border-t border-gray-800 text-xs text-gray-600 leading-relaxed">
                        <p className="mb-2 font-semibold text-gray-400">服務條款說明：</p>
                        <p className="mb-2">
                            本網站僅供產品資訊瀏覽，恕不提供線上交易。所有交付行為均由物流人員（或店取人員）核對身分證件後方可完成。
                        </p>
                        <p>按下詢價後，系統將自動推播 Line 訊息，由專員為您確認配送細節並完成後續交易流程。</p>
                    </div>
                </div>
            </footer>

            <div className="fixed bottom-0 left-0 w-full h-[10vh] bg-black z-50 flex flex-col justify-center items-center border-t-2 border-[#d4af37] shadow-[0_-10px_40px_rgba(0,0,0,0.5)]">
                <div className="flex flex-row items-center justify-center space-x-4 md:space-x-12 text-white">
                    <p className="text-[2.5vh] md:text-[4vh] font-black tracking-widest drop-shadow-md font-serif text-[#d4af37]">
                        {legal.warningLeft}
                    </p>
                    <div className="w-px h-[4vh] bg-[#d4af37]/50"></div>
                    <p className="text-[2.5vh] md:text-[4vh] font-black tracking-widest drop-shadow-md font-serif text-[#d4af37]">
                        {legal.warningRight}
                    </p>
                </div>
            </div>

            <div className="h-[10vh]"></div>
        </div>
    );
};

export default LandingPageModule;
